import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import { getWsbAuthProvider, requestContextEventHandler } from './utils';
async function load(app, options = {}) {
  app.events.once('plugin:auth-fe:load:auth-providers', loadAuthProvider => loadAuthProvider(getWsbAuthProvider(options)));
  app.events.on('page-load:get-initial-props:before', requestContextEventHandler);
  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}
load.pluginName = PLUGIN_NAME;
export default load;
//# sourceMappingURL=index.js.map